<template>
  <div class="exam-confim-container">
    <ExamHeader />
    <ExamineeinfoCard v-if="showExamineeinfoCard" @enter-exam="handleEnterExam" />
    <ExaminfoCard v-else />
  </div>
</template>

<script>
/* eslint-disable */
import ExamHeader from "@/components/ExamHeader.vue";
import ExamineeinfoCard from "./components/ExamineeinfoCard.vue";
import ExaminfoCard from "./components/ExaminfoCard.vue";

export default {
  name: 'ConfirmPage',
  components: {
    ExamHeader,
    ExamineeinfoCard,
    ExaminfoCard
  },
  data() {
    return {
      showExamineeinfoCard: true
    };
  },
  methods: {
    handleEnterExam() {
      this.showExamineeinfoCard = false;
    }
  }
};
</script>

<style scoped>
.exam-confim-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
}

.exam-perinfo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  height: 100vh;
}

.exam-info-card {
  max-width: 520px;
  width: 100%;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.student-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.student-photo {
  width: 100px;
  height: 110px;
  border-radius: 5px;
  object-fit: cover;
  border: 1px solid #ddd;
}

.info-item {
  margin: 5px 0;
  font-size: 14px;
}

.info-title {
  font-size: 25px;
  font-family: 'Arial Black', 'SimHei', sans-serif;
  font-weight: 900;
  text-shadow: 0.1px 0.1px 0 #000;
}

.code {
  color: #409eff;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}

.enter-exam-button {
  width: 100%;
}
</style>